
// import React, { useEffect, useState } from 'react';
// import { Line } from 'react-chartjs-2';
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
// } from 'chart.js';
// import { Box, FormControl, InputLabel, Select, MenuItem, Typography } from '@mui/material';
// import mockData from './mockData';
// import { useAuth } from '../AuthContext';

// // Register Chart.js components
// ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

// const PumpPerformanceChart = () => {
//   const [timePeriod, setTimePeriod] = useState('last_7_days');
//   const [metric, setMetric] = useState('energy');
// const {dashboardData,fetchDashboardData}=useAuth();

//   // Select data based on time period
//   const dataSource=dashboardData?.last_7_days_aggregates
// //const dataSource = mockData[timePeriod];
// console.log('this is the dashboard data',dashboardData)
//   // Metric configuration
//   const metricConfig = {
//     energy: {
//       label: 'Energy Produced (kWh)',
//       key: 'total_energy_produced',
//       borderColor: 'rgba(75, 192, 192, 1)',
//       backgroundColor: 'rgba(75, 192, 192, 0.2)',
//       yAxisTitle: 'Energy Produced (kWh)',
//       unit: 'kWh',
//     },
//     running_time: {
//       label: 'Running Time (minutes)',
//       key: 'total_running_time',
//       borderColor: 'rgba(255, 99, 132, 1)',
//       backgroundColor: 'rgba(255, 99, 132, 0.2)',
//       yAxisTitle: 'Running Time (minutes)',
//       unit: 'minutes',
//     },
//     water_discharged: {
//       label: 'Water Discharged (liters)',
//       key: 'total_water_discharged',
//       borderColor: 'rgba(54, 162, 235, 1)',
//       backgroundColor: 'rgba(54, 162, 235, 0.2)',
//       yAxisTitle: 'Water Discharged (liters)',
//       unit: 'liters',
//     },
//   };

//   // Prepare chart data
//   const labels = dataSource.map((item) => item.date);
//   const selectedMetric = metricConfig[metric];
//   const datasets = [
//     {
//       label: selectedMetric.label,
//       data: dataSource.map((item) => item[selectedMetric.key]),
//       borderColor: selectedMetric.borderColor,
//       backgroundColor: selectedMetric.backgroundColor,
//       fill: false,
//     },
//   ];

//   const chartData = {
//     labels,
//     datasets,
//   };

//   const options = {
//     responsive: true,
//     maintainAspectRatio: false, // Allow chart to fill parent height
//     plugins: {
//       legend: {
//         position: 'top',
//       },
//       title: {
//         display: true,
//         text: `Pump Performance - ${timePeriod.replace('_', ' ').toUpperCase()}`,
//       },
//       tooltip: {
//         callbacks: {
//           label: (context) => {
//             const { dataset, raw } = context;
//             return `${dataset.label}: ${raw} ${selectedMetric.unit}`;
//           },
//         },
//       },
//     },
//     scales: {
//       x: {
//         title: {
//           display: true,
//           text: timePeriod.includes('month') ? 'Month' : 'Date',
//         },
//       },
//       y: {
//         title: {
//           display: true,
//           text: selectedMetric.yAxisTitle,
//         },
//         beginAtZero: true,
//       },
//     },
//   };

//   return (
//     <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: 1 }}>
//       <Typography variant="h4" gutterBottom  sx={{  pb: 2 }}>
//         Pump Performance
//       </Typography>
//       <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
//         <FormControl sx={{ minWidth: 150 }}>
//           <InputLabel>Time Period</InputLabel>
//           <Select
//             value={timePeriod}
//             label="Time Period"
//             onChange={(e) => setTimePeriod(e.target.value)}
//           >
//             <MenuItem value="last_7_days">Last 7 Days</MenuItem>
//             <MenuItem value="last_30_days">Last 30 Days</MenuItem>
//             <MenuItem value="last_6_months">Last 6 Months</MenuItem>
//             <MenuItem value="last_12_months">Last 12 Months</MenuItem>
//           </Select>
//         </FormControl>
//         <FormControl sx={{ minWidth: 150 }}>
//           <InputLabel>Metric</InputLabel>
//           <Select
//             value={metric}
//             label="Metric"
//             onChange={(e) => setMetric(e.target.value)}
//           >
//             <MenuItem value="energy">Energy Produced</MenuItem>
//             <MenuItem value="running_time">Running Time</MenuItem>
//             <MenuItem value="water_discharged">Water Discharged</MenuItem>
//           </Select>
//         </FormControl>
//       </Box>
//       <Box sx={{ flexGrow: 1, position: 'relative' }}>
//         <Line data={chartData} options={options} />
//       </Box>
//     </Box>
//   );
// };

// export default PumpPerformanceChart;




import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Box, FormControl, InputLabel, Select, MenuItem, Typography, CircularProgress } from '@mui/material';
import { useAuth } from '../AuthContext';

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const PumpPerformanceChart = () => {
  const [timePeriod, setTimePeriod] = useState('7');
  const [metric, setMetric] = useState('energy');
  const [loading, setLoading] = useState(true);
  const { dashboardData, fetchDashboardData, isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) return;
    const loadData = async () => {
      try {
        setLoading(true);
        await fetchDashboardData(timePeriod);
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [timePeriod, isAuthenticated]);

  // Select data based on time period
  const dataSource = dashboardData?.[`last_${timePeriod}_days_aggregates`] || [];

  // Metric configuration
  const metricConfig = {
    energy: {
      label: 'Energy Produced (kWh)',
      key: 'total_energy_produced',
      borderColor: 'rgba(75, 192, 192, 1)',
      backgroundColor: 'rgba(75, 192, 192, 0.2)',
      yAxisTitle: 'Energy Produced (kWh)',
      unit: 'kWh',
    },
    running_time: {
      label: 'Running Time (minutes)',
      key: 'total_running_time',
      borderColor: 'rgba(255, 99, 132, 1)',
      backgroundColor: 'rgba(255, 99, 132, 0.2)',
      yAxisTitle: 'Running Time (minutes)',
      unit: 'minutes',
    },
    water_discharged: {
      label: 'Water Discharged (liters)',
      key: 'total_water_discharged',
      borderColor: 'rgba(54, 162, 235, 1)',
      backgroundColor: 'rgba(54, 162, 235, 0.2)',
      yAxisTitle: 'Water Discharged (liters)',
      unit: 'liters',
    },
  };

  // Prepare chart data
  const labels = dataSource.map((item) => item.date);
  const selectedMetric = metricConfig[metric];
  const datasets = [
    {
      label: selectedMetric.label,
      data: dataSource.map((item) => item[selectedMetric.key]),
      borderColor: selectedMetric.borderColor,
      backgroundColor: selectedMetric.backgroundColor,
      fill: false,
    },
  ];

  const chartData = {
    labels,
    datasets,
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: `Pump Performance - ${timePeriod.replace('_', ' ').toUpperCase()}`,
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const { dataset, raw } = context;
            return `${dataset.label}: ${raw} ${selectedMetric.unit}`;
          },
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: timePeriod.includes('month') ? 'Month' : 'Date',
        },
      },
      y: {
        title: {
          display: true,
          text: selectedMetric.yAxisTitle,
        },
        beginAtZero: true,
      },
    },
  };

  if (loading) {
    return (
      <Box sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  // if (!dataSource.length) {
  //   return (
  //     <Box sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
  //       <Typography variant="h6">No data available</Typography>
  //     </Box>
  //   );
  // }

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: 1 }}>
      <Typography variant="h4" gutterBottom sx={{ pb: 2 }}>
        Pump Performance
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <FormControl sx={{ minWidth: 150 }}>
          <InputLabel>Time Period</InputLabel>
          <Select
            value={timePeriod}
            label="Time Period"
            onChange={(e) => setTimePeriod(e.target.value)}
          >
            <MenuItem value="7">Last 7 Days</MenuItem>
            <MenuItem value="30">Last 30 Days</MenuItem>
            <MenuItem value="180">Last 6 Months</MenuItem>
            <MenuItem value="365">Last 12 Months</MenuItem>
          </Select>
        </FormControl>
        <FormControl sx={{ minWidth: 150 }}>
          <InputLabel>Metric</InputLabel>
          <Select
            value={metric}
            label="Metric"
            onChange={(e) => setMetric(e.target.value)}
          >
            <MenuItem value="energy">Energy Produced</MenuItem>
            <MenuItem value="running_time">Running Time</MenuItem>
            <MenuItem value="water_discharged">Water Discharged</MenuItem>
          </Select>
        </FormControl>
      </Box>
      {
        dataSource.length ?<Box sx={{ flexGrow: 1, position: 'relative' }}>
        <Line data={chartData} options={options} />
      </Box>:
      <Box sx={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Typography variant="h6">No data available</Typography>
    </Box>
      }
      
    </Box>
  );
};

export default PumpPerformanceChart;